import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import _get from 'hs-lodash/get';
export const formatContact = contact => {
  const firstName = _get(contact, 'properties.firstname', '');
  const lastName = _get(contact, 'properties.lastname', '');
  const email = _get(contact, 'properties.email', '');
  let optionText = email;
  if (firstName && lastName) {
    optionText = formatName({
      firstName,
      lastName
    });
  } else {
    optionText = email || '';
  }
  return Object.assign({}, contact, {
    text: optionText
  }, email && {
    supportText: email
  }, {
    value: JSON.stringify({
      id: contact.id,
      firstName,
      lastName,
      email
    })
  });
};
const formatCompany = company => {
  const name = _get(company, 'properties.name', '');
  const domain = _get(company, 'properties.domain', '');
  const optionText = `${name} ${domain}`;
  return Object.assign({}, company, {
    text: optionText
  }, domain && {
    supportText: domain
  }, {
    value: JSON.stringify({
      id: company.id,
      name,
      domain
    })
  });
};
const formatDeal = deal => {
  const dealname = _get(deal, 'properties.dealname', '');
  const dealstage = _get(deal, 'properties.dealstage', '');
  const optionText = `${dealname} ${dealstage}`;
  return Object.assign({}, deal, {
    text: optionText,
    value: JSON.stringify({
      id: deal.id,
      dealname,
      dealstage
    })
  });
};
const formatTicket = ticket => {
  const subject = _get(ticket, 'properties.subject', '');
  const hs_pipeline_stage = _get(ticket, 'properties.hs_pipeline_stage', '');
  const optionText = `${subject} ${hs_pipeline_stage}`;
  return Object.assign({}, ticket, {
    text: optionText,
    value: JSON.stringify({
      id: ticket.id,
      subject,
      hs_pipeline_stage
    })
  });
};
const formatMeeting = meeting => {
  const title = _get(meeting, 'properties.hs_meeting_title', '');
  const hs_createdate = _get(meeting, 'properties.hs_createdate', '');
  const createDate = I18n.moment(hs_createdate);
  const optionText = `${title} ${hs_createdate ? createDate.fromNow() : ''}`;
  return Object.assign({}, meeting, {
    text: optionText,
    value: JSON.stringify({
      id: meeting.id,
      title,
      hs_createdate
    })
  });
};
export const formatObject = (item, objectType) => {
  const formatFunctions = {
    contacts: formatContact,
    companies: formatCompany,
    deals: formatDeal,
    tickets: formatTicket,
    meetings: formatMeeting
  };
  return formatFunctions[objectType](item);
};